import React from 'react'

const GasPlug = ({color}) => {
  return (
    <svg viewBox="0 0 65 65">
      <path
        fill={color ? color : '#3F5063'}
        d="M47.2,53c-9.2,0-16.8-7.4-16.8-16.6c0-8.1,4.1-12.2,4.2-12.4c0.3-0.3,0.7-0.4,1.1-0.2c0.4,0.2,0.6,0.5,0.6,0.9
	c0,0.3,0,5.6,3.9,8.4c-2.5-9.7,2.3-13.5,6.2-16.7c1.6-1.3,3.1-2.5,3.8-3.9c0.2-0.5,0.8-0.7,1.3-0.5c0.5,0.2,0.7,0.7,0.6,1.2
	c-1.7,5,0.5,10.9,2.2,14.4c0.4-2.3,1.4-5.4,4.1-7.7c0.3-0.3,0.8-0.3,1.2-0.1c0.4,0.2,0.6,0.7,0.5,1.1c-0.9,3.7,0.2,5.3,1.4,7.4
	c1.2,1.9,2.5,4,2.5,8C64,45.6,56.5,53,47.2,53z M34.7,27.4c-1,1.8-2.2,4.8-2.2,9c0,8,6.6,14.6,14.8,14.6S62,44.5,62,36.4
	c0-3.4-1.1-5.2-2.2-6.9c-1-1.5-1.9-3.1-2-5.5c-1.9,3.3-1.6,7.1-1.6,7.1c0,0.5-0.2,0.9-0.7,1c-0.4,0.2-0.9,0-1.2-0.4
	c-0.2-0.4-5.1-7.8-4.8-15.2c-0.6,0.5-1.1,1-1.7,1.4c-4.1,3.3-8.3,6.7-4.8,16.8c0.1,0.4,0,0.8-0.2,1c-0.3,0.3-0.7,0.4-1,0.2
	C36.9,34.3,35.3,30.1,34.7,27.4z"
      />
      <path
        fill={color ? color : '#6EC18A'}
        d="M13.8,53c-0.6,0-1-0.4-1-1v-4.2h-1.6c-0.6,0-1-0.4-1-1v-5.2c0-0.6,0.4-1,1-1s1,0.4,1,1v4.2h3.3v-4.2
	c0-0.6,0.4-1,1-1s1,0.4,1,1v5.2c0,0.6-0.4,1-1,1h-1.6V52C14.8,52.6,14.4,53,13.8,53z"
      />
      <path
        fill={color ? color : '#3F5063'}
        d="M16.4,42.6h-5.3c-4.2,0-7.6-3.4-7.6-7.5V24.4H2c-0.6,0-1-0.4-1-1s0.4-1,1-1h5.6V13c0-0.6,0.4-1,1-1s1,0.4,1,1
	v9.4h8.5V13c0-0.6,0.4-1,1-1s1,0.4,1,1v9.4h5.6c0.6,0,1,0.4,1,1s-0.4,1-1,1H24v10.7c0,2-0.8,3.9-2.2,5.3
	C20.4,41.8,18.5,42.6,16.4,42.6z M5.6,24.4v10.7c0,3,2.5,5.5,5.6,5.5h5.3c1.5,0,2.9-0.6,3.9-1.6c1-1,1.6-2.4,1.6-3.9V24.4H5.6z"
      />
    </svg>
  )
}

export default GasPlug
